// extracted by mini-css-extract-plugin
export var footer = "Footer-module--footer--VRb5f";
export var footer__main = "Footer-module--footer__main--XFnTd";
export var footer__subBar = "Footer-module--footer__sub-bar--1wfih";
export var footer__disclosure = "Footer-module--footer__disclosure--2roHj";
export var footer__logo = "Footer-module--footer__logo--2rFHs";
export var footerNav = "Footer-module--footer-nav--Kgdep";
export var footerNav__clientLogin = "Footer-module--footer-nav__client-login--rqVuu";
export var footerNav__item = "Footer-module--footer-nav__item--qPGdB";
export var footerSocial = "Footer-module--footer-social--3mlrX";
export var footerSocial__item = "Footer-module--footer-social__item--2BK9Q";
export var footerDesktopClientLogin = "Footer-module--footer-desktop-client-login--3pxtU";